import { gql } from '@apollo/client';

export const EXPORT_REALTIME_SETTLEMENT_DAILY_SUM = gql`
  mutation ExportRealtimeSettlementDailySum(
    $filters: RealtimeSettlementOrderDailySumFilterTypeInput
  ) {
    exportRealtimeSettlementDailySum(filters: $filters) {
      success
      message
      messageKey
      data
    }
  }
`;
